import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { BiRefresh } from 'react-icons/bi';
import ModalComp from "../common/ModalComp";
import ChangePwd from "../login/ChangePwd";

const SideBar = () => {
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [empBasicShowPwd, setEmpBasicShowPwd] = useState(false);

  const handleOpenModal = () => setEmpBasicShowPwd(true);
  const handleCloseModal = () => setEmpBasicShowPwd(false);
  const signOut = () => {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error("Error clearing sessionStorage:", error);
    }
    // Navigate to login page
    // navigate('/my-login');
  };
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);

  }

  const changePassword = () => {
    setEmpBasicShowPwd(true);

  }
  return (
    <>
      <header id="header" className="header d-flex align-items-center" style={{ position: 'sticky', top: 0, fontSize: '20px' }}>
        {/* <div className="d-flex align-items-center justify-content-between"> */}
        <div className={`d-flex align-items-center justify-content-between ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
          <i className="bi bi-list toggle-sidebar-btn" onClick={toggleSidebar}></i>
          <div style={{ color: 'darkslateblue' }}> <b> Department of Health Medical and Family Welfare </b> </div>
        </div>


        <nav className="header-nav ms-auto">
          <ul className="d-flex align-items-center">



            <li className="nav-item dropdown pe-3">
              <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                {/* <img src="assets/img/profile-img.jpg" alt="Profile" className="rounded-circle" /> */}
                <span className="d-none d-md-block dropdown-toggle ps-2">{sessionStorage.getItem("userFullName")}</span>  </a>


              <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                <li className="dropdown-header">
                  <h6>{sessionStorage.getItem("userFullName")}</h6>
                  {/* <span>{sessionStorage.getItem("userRoleName")}</span> */}
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>

                <li>
                  <a className="dropdown-item d-flex align-items-center" href="users-profile.html">
                    <i className="bi bi-person"></i>
                    <span>My Profile</span>
                  </a>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link className="dropdown-item d-flex align-items-center" onClick={changePassword}>
                    <i className="bi bi-box-arrow-right"></i>
                    <span >Change Password</span>
                  </Link>
                  {/* <Button onClick={signOut} > Sign Out  </Button> */}
                </li>

                <li>
                  <Link className="dropdown-item d-flex align-items-center" onClick={signOut} to="/my-login">
                    <i className="bi bi-box-arrow-right"></i>
                    <span >Sign Out</span>
                  </Link>
                  {/* <Button onClick={signOut} > Sign Out  </Button> */}
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </header>

      {/* <aside id="sidebar" className="sidebar"> */}
      <aside id="sidebar" className={`sidebar ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="d-flex align-items-center justify-content-between mb-3 p-2 logowrapper">
          <a href="index.html" className="logo d-flex align-items-center">
            <img src="assets/img/logo.png" alt="" />
            <span className="d-lg-block">
              Government of Telangana
            </span>
          </a>
        </div>
        <ul className="sidebar-nav" id="sidebar-nav">



          <li className="nav-item">
            <Link
              className="nav-link"
              data-bs-target="#charts-nav"
              data-bs-toggle="collapse"
              to="#"
            >
              <i className=""></i><span> Approval</span>
              <i className="bi bi-chevron-down ms-auto"></i>
            </Link>
            <ul
              id="charts-nav"
              className="nav-content collapse"
              data-bs-parent="#sidebar-nav"
            >
              <li className="nav-item">
                <Link className="nav-link" to="/pending">
                  <i className="bi bi-circle"></i><span>Noc Approval</span>
                </Link>
              </li>
            </ul>

            <ul
              id="charts-nav"
              className="nav-content collapse"
              data-bs-parent="#sidebar-nav"
            >
              <li className="nav-item">
                <Link className="nav-link" to="/approved">
                  <i className="bi bi-circle"></i><span>Approved List</span>
                </Link>
              </li>
            </ul>
          </li>
        </ul>


        {sessionStorage.getItem('userRole') === 'CD4' || sessionStorage.getItem('userRole') === 'CD5' ? (
          <ul className="sidebar-nav" id="sidebar-nav">
            <li className="nav-item">
              <Link
                className="nav-link"
                data-bs-target="#charts-nav"
                data-bs-toggle="collapse"
                to="#"
              >
                <i className=""></i><span>Dashboard</span>
                <i className="bi bi-chevron-down ms-auto"></i>
              </Link>
            </li>
            <ul
              id="charts-nav"
              className="nav-content collapse"
              data-bs-parent="#sidebar-nav"
            >
              {/* {sessionStorage.getItem('userRole') === 'CD4' || sessionStorage.getItem('userRole') === 'CD5' ? ( */}
              <li className="nav-item">
                <Link className="nav-link" to="/dashboard">
                  <i className="bi bi-circle"></i><span>Dashboard</span>
                </Link>
              </li>
              {/* ) : ''} */}
            </ul>
          </ul>
        ) : ''}


      </aside>

      <ModalComp
        size={"lg"}
        show={empBasicShowPwd}
        handleClose={handleCloseModal}
        modalTitle={"Change Password"}
        modalBody={<ChangePwd></ChangePwd>}
      />

    </>
  )
}

export default SideBar;